import React from "react";
import { ChevronRight, Plus, Save, Trash2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { difficultyLabels, formatRunTime, intervalTypeNames } from "../../constants/running";

// Create/edit form for a running plan and its intervals.
const RunningPlanEditor = ({
  addInterval,
  editingRunningPlan,
  newInterval,
  newRunningPlan,
  removeInterval,
  saveRunningPlan,
  setNewInterval,
  setNewRunningPlan,
  setRunningView,
}) => {
  return (
    <div className="plan-editor-view">
      <Button variant="ghost" size="sm" onClick={() => setRunningView("list")}><ChevronRight size={16} className="rotate-180" /> Powrót</Button>
      <h2>{editingRunningPlan ? "Edytuj plan" : "Nowy plan biegowy"}</h2>

      <div className="field"><Label>Nazwa</Label><Input value={newRunningPlan.name} onChange={(e) => setNewRunningPlan(p => ({...p, name: e.target.value}))} placeholder="np. Mój trening interwałowy" /></div>
      <div className="field"><Label>Opis</Label><Textarea value={newRunningPlan.description} onChange={(e) => setNewRunningPlan(p => ({...p, description: e.target.value}))} /></div>
      <div className="field"><Label>Cel</Label><Input value={newRunningPlan.goal} onChange={(e) => setNewRunningPlan(p => ({...p, goal: e.target.value}))} placeholder="np. 5km poniżej 25 min" /></div>
      <div className="field"><Label>Trudność</Label>
        <Select value={newRunningPlan.difficulty} onValueChange={(v) => setNewRunningPlan(p => ({...p, difficulty: v}))}>
          <SelectTrigger><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="easy">Łatwy</SelectItem>
            <SelectItem value="medium">Średni</SelectItem>
            <SelectItem value="hard">Trudny</SelectItem>
            <SelectItem value="expert">Ekspert</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="fields-row">
        <div className="field"><Label>Dystans (km)</Label><Input type="number" step="0.1" value={newRunningPlan.estimated_distance_km} onChange={(e) => setNewRunningPlan(p => ({...p, estimated_distance_km: e.target.value}))} /></div>
        <div className="field"><Label>Czas (min)</Label><Input type="number" value={newRunningPlan.estimated_duration_minutes} onChange={(e) => setNewRunningPlan(p => ({...p, estimated_duration_minutes: e.target.value}))} /></div>
      </div>

      <h3>Interwały ({newRunningPlan.intervals.length})</h3>
      {newRunningPlan.intervals.map((interval, idx) => (
        <div key={idx} className={`interval-editor-item interval-${interval.type}`}>
          <span>{idx + 1}. {intervalTypeNames[interval.type]} - {formatRunTime(interval.duration_seconds)}</span>
          {interval.target_pace_min && <span className="interval-pace-sm"> ({interval.target_pace_min}-{interval.target_pace_max} min/km)</span>}
          <Button variant="ghost" size="sm" onClick={() => removeInterval(idx)}><Trash2 size={14} /></Button>
        </div>
      ))}

      <Card className="add-interval-card">
        <CardContent>
          <h4>Dodaj interwał</h4>
          <div className="interval-form-grid">
            <div className="field"><Label>Typ</Label>
              <Select value={newInterval.type} onValueChange={(v) => setNewInterval(p => ({...p, type: v}))}>
                <SelectTrigger><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="warmup">Rozgrzewka</SelectItem>
                  <SelectItem value="run">Bieg</SelectItem>
                  <SelectItem value="sprint">Sprint</SelectItem>
                  <SelectItem value="recovery">Odpoczynek</SelectItem>
                  <SelectItem value="walk">Marsz</SelectItem>
                  <SelectItem value="cooldown">Schładzanie</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="field"><Label>Czas (sekundy)</Label><Input type="number" value={newInterval.duration_seconds} onChange={(e) => setNewInterval(p => ({...p, duration_seconds: e.target.value}))} /></div>
            <div className="field"><Label>Tempo min (min/km)</Label><Input type="number" step="0.1" value={newInterval.target_pace_min} onChange={(e) => setNewInterval(p => ({...p, target_pace_min: e.target.value}))} placeholder="np. 5.0" /></div>
            <div className="field"><Label>Tempo max (min/km)</Label><Input type="number" step="0.1" value={newInterval.target_pace_max} onChange={(e) => setNewInterval(p => ({...p, target_pace_max: e.target.value}))} placeholder="np. 6.0" /></div>
            <div className="field"><Label>Opis</Label><Input value={newInterval.description} onChange={(e) => setNewInterval(p => ({...p, description: e.target.value}))} placeholder="np. Lekki trucht" /></div>
          </div>
          <Button variant="outline" onClick={addInterval} className="mt-2"><Plus size={14} /> Dodaj interwał</Button>
        </CardContent>
      </Card>

      <Button className="save-plan-btn" onClick={saveRunningPlan}><Save size={16} /> Zapisz plan</Button>
    </div>
  );
};

export default RunningPlanEditor;
